let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6pPGD")).then(() => parcelRequire('5UhMk'));